import { Component } from './live-codec.js';

// Blood from `explode` is authored on the client-created gib models. The
// server sends the gib ragdoll flag, rather than a blood-particle temp entity.
export function modelParticleSpecs(entity) {
    if (!entity.rig || entity.pending || entity.object.visible === false) return [];
    const death = entity.state.components[Component.Ragdoll];
    // C_TFRagdoll disables model particles on the original player corpse;
    // its separately created gibs initialize their own model particles.
    if (death && !entity.owner) return [];
    const authored = entity.rig.data.particleEffects ?? [];
    const effects = entity.owner && entity.gibBurning
        ? [...authored, { name: 'burninggibs', attachType: 4, attachmentName: 'bloodpoint' }] : authored;
    const result = [];
    for (const effect of effects) {
        if (effect.attachmentName && !entity.rig.attachments.some(point => point.name.toLowerCase() === effect.attachmentName.toLowerCase())) break;
        if ((effect.attachType === 3 || effect.attachType === 4) && effect.attachment > 0
            && !entity.rig.attachments[effect.attachment - 1]) break;
        result.push({ ...effect, ownerKey: entity.key, source: entity.key, flags: 1,
            startTime: death?.startTime ?? entity.state.sampleTime, automatic: true,
            offset: [0, 0, 0], controlPoints: [] });
    }
    return result;
}
